//日志维护
export default [
    {
        path: 'LogManagement',
        name: 'LogManagement',
        meta: {
            title: '日志管理',
            icon: 'LogManagement'
        },
        hidden: false,
        component: () => import("@/views/research/LogManagement/index.vue"),
        children: [{
            path: 'logMaintenance',
            name: 'logMaintenance',
            meta: {
                title: '日志维护',
                icon: 'logMaintenance'
            },
            hidden: false,
            component: () => import("@/views/research/LogManagement/logMaintenance.vue"),
        }, {
            path: 'backstageLog',
            name: 'backstageLog',
            meta: {
                title: '后台访问日志',
                icon: 'backstageLog'
            },
            hidden: false,
            component: () => import("@/views/research/LogManagement/backstageLog.vue"),
        }, {
            path: 'appLog',
            name: 'appLog',
            meta: {
                title: 'APP访问日志',
                icon: 'appLog'
            },
            hidden: false,
            component: () => import("@/views/research/LogManagement/appLog.vue"),
        }]
    }

]